import { Box, styled } from '@mui/material';

export const MarketStockExchangeContainer = styled(Box)(() => ({
  width: '100%',
}));

export const WrapperCards = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  alignItems: 'center',
  margin: '12px 32px 24px 32px',
}));

export const SectionStyled = styled('section')(({ theme }) => ({
  borderTop: `solid 1px ${theme.palette.colors.lower}`,
  paddingTop: '23px',
  display: 'flex',
  alignItems: 'center',
  gap: '40px',
  height: '87px',
}));

export const MarketDetail = styled(Box)(({ theme }) => {
  const isFirefox = typeof InstallTrigger !== 'undefined';

  return {
    marginLeft: '-32px',
    backgroundColor: theme.palette.colors.selectedAndDetailBackground,
    position: 'fixed',
    bottom: 0,
    width: isFirefox ? '-moz-available' : '-webkit-fill-available',
    zIndex: 99,
  };
});

export const DetailsContainer = styled(Box)(() => ({
  display: 'flex',
  height: '320px',
  marginBottom: '32px',
}));

export const DetailLeft = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'currentTab',
})(({ theme, currentTab }) => ({
  width: '50%',
  margin: '0 12px 0 32px',
  borderRadius: '5px',
  backgroundColor: theme.palette.colors.primaryBackground,

  '& #tabsContainer': {
    margin: currentTab === 1 ? '24px 58px 48px 40px' : '24px 58px 16px 40px',
  },

  '& .stockExchangeDetailsTab': {
    height: currentTab === 1 ? '211px' : '243px',

    '& > *': {
      height: '100%',

      '& > *': {
        height: '100%',
      },
    },
  },
}));

export const DetailRight = styled(Box)(({ theme }) => ({
  width: '50%',
  margin: '0 32px 0 12px',
  borderRadius: '5px',
  backgroundColor: theme.palette.colors.primaryBackground,
}));

export const DesktopContentContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'mainContentOffsetTop',
})(({ mainContentOffsetTop }) => ({
  height: `calc(100vh - ${mainContentOffsetTop}px - 11px)`,
}));
